<div class="all-content">
    <div class="top">
        {{ getLanguages('crmTree') }}
    </div>
    <div class="row">
        <div class="div-search" [ngClass]="isSearch ? 'div-search-fixed' : ''">
            <div class="search">
                <input type="text" [(ngModel)]="text" (keyup.enter)="searchNodes()">
                <i class="fas fa-xmark cancel-search" *ngIf="isSearch" (click)="clearFilter()"></i>
            </div>
            <button (click)="searchNodes()">
                {{ getLanguages('search') }}
            </button>

            <div class="filter-section count-proccess" *ngIf="isSearch">
                <div class="filter" *ngIf="filterArray?.length > 0">
                    {{ filterCursor }}
                    {{ getLanguages('businessSolution/search/of') }}
                    {{ filterArray?.length }}
                    <button class="button-navigation" (click)="previous()"
                        [class.disabled-button-filter]="filterCursor === 1" [disabled]="filterCursor === 1"> <i
                            class="fas fa-chevron-left"></i> </button>
                    <button class="button-navigation" (click)="next()"
                        [class.disabled-button-filter]="filterCursor === filterArray.length"
                        [disabled]="filterCursor === filterArray.length"> <i class="fas fa-chevron-right"></i> </button>
                </div>
                <span *ngIf="filterArray?.length == 0">
                    {{ getLanguages('businessSolution/search/noResult') }}
                </span>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="div-buttons">
            <div class="button-save">
                <button (click)="finishedCopyClone()" *ngIf="isPaste" class="finished-button button-tooltip">
                    {{ getLanguages('businessSolution/top/info/finished') }}
                </button>
                <button (click)="saveTree(null, crm_tree.uuid)" [disabled]="!isEdited"
                    class="left-button button-tooltip" [ngClass]="!isEdited ? 'disabled no-pointer' : ''"
                    *ngIf="getSystemPermission('crm_tree', 'save_tree') && isEdited">
                    {{ getLanguages('saveChangesTree') }}
                </button>
            </div>
            <button (click)="toggleUpload()" class="button-tooltip left-button"
                *ngIf="getSystemPermission('crm_tree', 'import')">
                {{ getLanguages('businessSolution/top/info/import') }}
            </button>
            <div class="button-save" *ngIf="getSystemPermission('crm_tree', 'export')">
                <button class="save" [matMenuTriggerFor]="selectExport">
                    {{ getLanguages('businessSolution/top/info/export') }}
                    <i class="fas fa-angle-down" style="margin-left: 2vh;"></i>
                </button>
                <mat-menu #selectExport="matMenu">
                    <button (click)="getTreeXls('json')" class="menu-button">
                        {{ getLanguages('businessSolution/top/info/export/json') }}
                    </button>
                    <button (click)="getTreeXls('xls')" class="menu-button">
                        {{ getLanguages('businessSolution/top/info/export/xls') }}
                    </button>
                </mat-menu>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="isEdited">
        <div class="alert-save">
            <div class="toggle-save"></div>
            {{ getLanguages('auth/alert/isEdited') }}
        </div>
    </div>
    <div class="content">
        <div class="title">
            <span>
                {{ getLanguages('crmTree/content/title') }}
            </span>
            <section>
                <div class="toggle-tooltip">
                    <div class="item-op">
                        {{ getLanguages('businessSolution/top/info/diagram') }}
                    </div>
                </div>
            </section>
            <i class="fas fa-plus" (click)="loadModal(1, {}, $event)"
                *ngIf="getSystemPermission('crm_tree', 'create_process')"></i>
            <mat-menu #selectNewLevel="matMenu" class="custom-menu">
                <button (click)="loadModal(1, getModifiedNode({}, item?.level - 1 ))"
                    [ngClass]="item?.level == -1 ? 'fixed-level-button' : ''" class="menu-button custom-menu-item"
                    *ngFor="let item of menuLevelArray">
                    {{ item.name }}
                </button>
            </mat-menu>
            <button [matMenuTriggerFor]="selectNewLevel" #menuTrigger="matMenuTrigger"
                style="width: 0; height: 0;border: none; padding: 0;"></button>
            <span class="paste-here" (click)="pasteCopyNode({}, $event)"
                *ngIf="(getSystemPermission('crm_tree', 'copy_process') || getSystemPermission('crm_tree', 'clone_process')) && isPaste && showPaste()">
                {{ getLanguages('pasteHere') }}
            </span>
        </div>
        <div class="content-content">
            <div class="tree" [ngStyle]="{'width': isResponsive() && (isShow || isShowEdit) ? '50%' : '50%'}">
                <div class="noData" *ngIf="noData && !isLoading">
                    <div class="icon">
                        <i class="fa-solid fa-exclamation"></i>
                    </div>
                    <span>
                        {{ getLanguages('errors/noData')}}
                    </span>
                </div>

                <p-tree class="ptree" [value]="files" *ngIf="!isLoading && !noData" selectionMode="single"
                    [(selection)]="selectedFile" (onNodeSelect)="loadModal(2, $event)"
                    (onNodeExpand)="onNodeExpand($event)" [expandedKeys]="expandedKeys">
                    <ng-template let-node pTemplate="default">
                        <div class="pcontent" id="{{ node.uuid }}">
                            <div class="ptitle">
                                <div class="ptitle-content">
                                    <div class="div-acronym"
                                        [ngClass]="node?.is_cut == true ? 'background-rose-2' : 'background-rose-1'"> {{
                                        getIconLevel(node?.level) }} </div>
                                    <div class="toggle-tooltip">
                                        <div class="item-op">
                                            {{ (node && node.label ? node.label : '') }}
                                        </div>
                                    </div>
                                </div>

                                <div class="circle-status" [ngClass]="getCircleClass(node)"></div>
                                <i class="fa-solid fa-thumbs-up" *ngIf="node.is_approved"></i>

                                <section>
                                    <div [class.error_node]="hasError(node.uuid)" class="button-tooltip">
                                        <span *ngIf='hasError(node.uuid)' class="point_error">
                                            *
                                        </span>
                                        <span [class.first-column]="isFirstColumn(node)" class="ptitle-content-text"
                                            [ngClass]="{
                                                'error-name': node?.error,
                                                'title-destak': filterArray.includes(node.uuid)
                                            }"> 
                                            {{ (node?.label ?? '') }}
                                            <i *ngIf="node?.error"
                                                class="fa-solid fa-triangle-exclamation error-icon"></i>
                                        </span>
                                    </div>
                                    <div class="toggle-tooltip" *ngIf="getNodeIntegrations(node).length || node?.error">
                                        <div *ngFor="let integration of getNodeIntegrations(node)" class="item-op">
                                            {{ integration.type }} - {{ integration.name }}
                                        </div>

                                        <div class="div-line-error"
                                            *ngIf="node?.error && getNodeIntegrations(node).length"></div>

                                        <div *ngIf="node?.error" class="item-op">
                                            {{ getLanguages('errors/businessTree/' + node?.error) }}
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <section *ngIf="showPaste(node) && (!node.is_cut || node?.is_cut == false)">
                                <div class="button button-tooltip" (click)="pasteCopyNode(node, $event)"
                                    *ngIf="(getSystemPermission('crm_tree', 'copy_process') || getSystemPermission('crm_tree', 'clone_process'))&& isPaste && node.level > 0">
                                    <i class="fas fa-paste i"></i>
                                </div>
                                <div class="toggle-tooltip margin-right-tooltip">
                                    <div class="item-op">
                                        {{ getLanguages('businessSolution/top/info/paste') }}
                                    </div>
                                </div>
                            </section>

                            <div class="p-icons-new" *ngIf="!isPaste">
                                <button class="button-menu" (click)="eventStopPropagation($event)"
                                    [matMenuTriggerFor]="menu" (menuOpened)="onMenuOpen(node)">
                                    <i class="fa-solid fa-ellipsis"></i>
                                </button>
                            </div>

                            <mat-menu #menu="matMenu" class="custom-menu">
                                <ng-container *ngFor="let item of menuArray">
                                    <ng-container *ngIf="item.condition(selectedNode)">
                                        <button mat-menu-item class="custom-menu-item"
                                            [class.no-pointer]="item.isInfo"
                                            (click)="handleMenuItemClick(item, $event)">
                                            <i [class]="item.icon"></i>
                                            <span>{{ item.name }}</span>
                                        </button>
                                    </ng-container>
                                </ng-container>
                            </mat-menu>
                        </div>
                    </ng-template>
                </p-tree>
            </div>
            <div class="form-modal" *ngIf="isShow || isShowEdit"
                [ngStyle]="{'width': !isResponsive() ? '100%' : 'calc(50% - 1vh)'}">
                <app-create *ngIf="isShow" (toggleModal)="loadModal(0)" (getBusinessTree)="getCrmTree()"
                    [properties]="properties" [parameters]="objectModal"
                    (updateFiles)="updateFiles($event)"></app-create>
                <app-edit *ngIf="isShowEdit" (emitNavigateOriginNode)="navigateOriginNode($event)"
                    (toggleModalEdit)="loadModal(0)" (getBusinessTree)="getCrmTree()" [properties]="properties"
                    [parameters]="objectModal" (updateFiles)="updateFiles($event)"></app-edit>
            </div>
        </div>
    </div>
</div>

<div class="background-modals"
    *ngIf="isShowImport || isLoadingExport || isLoading || sharedData.isShowModalChangeTree">
    <app-import *ngIf="isShowImport" (toggleImportModal)="toggleUpload()" (updateFiles)="updateFiles($event)"
        [properties]="properties" [parameters]="parameters" [type]="'crm_tree'"> </app-import>
    <app-loading *ngIf="isLoadingExport || isLoading"></app-loading>
    <app-changes-tree *ngIf="sharedData.isShowModalChangeTree" (toggleModal)="closeModalChange()" (save)="saveTree()"
        (close)="toggleChangeTree()"></app-changes-tree>
</div>

<div class="background-modals" style="z-index: 99999;" *ngIf="isShowAccessRestrictionModal || isShowDelete">
    <app-delete-component *ngIf="isShowDelete" (toggleDelete)="openCloseModalDelete(false)"
        (updateFiles)="updateFiles($event)" [parameters]="objectModal" [type]="1"></app-delete-component>
</div>